/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    isCard: {
      type: Boolean,
      default: true
    },
    swipe: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isShow: false,
      deltaX: '0px'
    };
  },
  computed: {
    miniStyle: function miniStyle() {
      var miniStyle = {};
      miniStyle.padding = '1rem 1rem .5rem';
      miniStyle.imgHeightWidth = '4.8rem';
      miniStyle.imgBorderRadius = '.24rem';
      miniStyle.translate3d = "translate3d(".concat(this.deltaX, ", 0px, 0px)");
      return miniStyle;
    }
  },
  methods: {}
};